import { render, staticRenderFns } from "./ClassicSwitch.vue?vue&type=template&id=3664d62a&scoped=true&"
import script from "./ClassicSwitch.vue?vue&type=script&lang=js&"
export * from "./ClassicSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ClassicSwitch.vue?vue&type=style&index=0&id=3664d62a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664d62a",
  null
  
)

export default component.exports